import type { PaymentMethodsConfig } from '../default/payment';
import type { DeepPartial } from '../default/types';

export const paymentMethodsConfig: DeepPartial<PaymentMethodsConfig> = {
  paymentMethods: {
    imageBased: ['visa', 'mastercard', 'amex', 'diners', 'discover', 'paypal'],
    textBased: ['invoice', 'installments', 'bank_debit'],
  },
};
